export default __webpack_public_path__ + "static/media/cf4.5b088fb7.jpg";